var _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConductorLungPunctat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 80,
    viewBox: "0 0 116 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 38.25,
    x2: 24,
    y2: 38.25,
    stroke: "black",
    strokeWidth: 3.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 38.25,
    x2: 50,
    y2: 38.25,
    stroke: "black",
    strokeWidth: 3.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 63,
    y1: 38.25,
    x2: 77,
    y2: 38.25,
    stroke: "black",
    strokeWidth: 3.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 38.25,
    x2: 104,
    y2: 38.25,
    stroke: "black",
    strokeWidth: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConductorLungPunctat);
export default __webpack_public_path__ + "static/media/conductor_lung_punctat.1381d5073341726242632254d9dfedef.svg";
export { ForwardRef as ReactComponent };